import ContinReport from './ContinReport';

export default ContinReport;
